import forEach from "./for-each.js";

function toSignedInt32(x) {
    return x | 0;
}

/**
 * Generates a 32 bit seed by the current time.
 */
function generateSeed() {
    var seed = (new Date()).getTime();
    return toSignedInt32(seed);
}

function random(gameState) {
    function isInteger32(x) {
        return toSignedInt32(x) === x;
    }

    var seed = gameState.seed;

    if (!isInteger32(seed)) {
        throw new Error("Invalid seed found in game state. Must be a 32 bit integer. Actual seed: " + gameState.seed);
    }

    // mulberry32: the whole RNG state is the single 32-bit gameState.seed, so the
    // game state stays serializable / clone-safe with just one int (same contract
    // as before), but each draw is ~5 ops instead of rebuilding a 624-word
    // Mersenne Twister every call (that rebuild was ~30% of core-sim CPU). It is a
    // pure, deterministic function of the seed. The value *sequence* differs from
    // the old MT, which is safe here: replays are event-log playback (not
    // re-simulation) and never store the seed, and the client never reproduces the
    // server's RNG (the server is authoritative). See random.js history / notes.
    seed = (seed + 0x6D2B79F5) | 0;
    gameState.seed = seed;
    var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

function randInt(gameState, low, high) {
    return Math.floor(random(gameState) * (high - low) + low);
}

function randomElementIndex(gameState, list) {
    return randInt(gameState, 0, list.length);
}

function randomElement(gameState, list) {
    return list[randomElementIndex(gameState, list)];
}

function randomObjectProperty(gameState, object) {
    var list = [];
    forEach(object, function (value, property) {
        list.push(property);
    });
    return randomElement(gameState, list);
}

function randomObjectValue(gameState, object) {
    var list = [];
    forEach(object, function (value, property) {
        list.push(property);
    });
    return object[randomElement(gameState, list)];
}


function randomPermutation(gameState, n, avoidFixedPoints) {
    var elementsLeft = [];
    for (var i = 0; i < n; i++) {
        elementsLeft.push(i);
    }
    var res = new Array(n);
    for (i = 0; i < n; i++) {
        var index = randomElementIndex(gameState, elementsLeft);
        while (avoidFixedPoints && n > 1 && (elementsLeft[index] === i || i === n - 2 && elementsLeft[index ^ 1] === n - 1)) {
            index = randomElementIndex(gameState, elementsLeft);
        }
        res[i] = elementsLeft.splice(index, 1)[0];
    }
    return res;

}

export {
    generateSeed,
    random,
    randInt,
    randomElementIndex,
    randomElement,
    randomObjectProperty,
    randomObjectValue,
    randomPermutation
};
